// removed by extract-text-webpack-plugin
module.exports = {"item":"_3WI6nDhumLF8UZm9Z8bTJf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/opportunityListItem.less
// module id = 625
// module chunks = 0